import {
    createApp
} from "vue";
import App from "./App.vue";
import piniaPluginPersist from "pinia-plugin-persist";
import {
    createPinia
} from 'pinia'
const pinia = createPinia()
pinia.use(piniaPluginPersist);
import router from "./router";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import elTableInfiniteScroll from "el-table-infinite-scroll";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './assets/common.css'
import '@/utils/permissions'
import i18n from "./assets/lang/index"; //国际化
const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}
// const _ResizeObserver = window.ResizeObserver;
// window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
//     constructor(callback) {
//         callback = debounce(callback, 16);
//         super(callback);
//     }
// }
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(pinia)
app.use(router)
app.use(ElementPlus)
app.use(i18n)
app.use(elTableInfiniteScroll)

app.config.warnHandler = () => null;
app.directive('Loadmore',
    (el, binding) => {
        const child = el.querySelector('.select-trigger')
        if (child) {
            const id = child.getAttribute('aria-describedby')
            const poper = document.getElementById(id)
            const SELECTDOWN_DOM = poper && poper.querySelector('.el-scrollbar .el-select-dropdown__wrap')
            SELECTDOWN_DOM && SELECTDOWN_DOM.addEventListener('scroll', function () {
                const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (CONDITION) {
                    binding.value();
                }
            })
        }

    })
app.mount("#app")